import { get } from 'utils/api';

export const getLiveChargingSessions = (data) => {
  return get('/charger_bookings/livechargersession', data);
};

export const liveChagingSession = {
  getLiveChargingSessions,
};
